import React, {Component} from 'react'
import { HOSTS } from './../lib/helper'
import CPanelFormInputFields from './inputfields/cpanel'
import FlywheelFormInputFields from './inputfields/flywheel'
import HostingerFormInputFields from './inputfields/hostinger'
import GenericFormInputFields from './inputfields/generic'
import CloudwaysFormInputFields from './inputfields/cloudways'
import WPServeurFormInputFields from './inputfields/wpserveur'
import WPEngineFormInputFields from './inputfields/wpengine'
import BluehostFormInputFields from './inputfields/bluehost'
import SiteGroundFormInputFields from './inputfields/siteground'
import HostGatorFormInputFields from './inputfields/hostgator'
import GoDaddyFormInputFields from './inputfields/godaddy'
import LiquidWebFormInputFields from './inputfields/liquidweb'
import NexcessFormInputFields from './inputfields/nexcess'
import SavviiFormInputFields from './inputfields/savvii'
import WeFosterFormInputFields from './inputfields/wefoster'
import InterServerFormInputFields from './inputfields/interserver'
import JaguarPCFormInputFields from './inputfields/jaguarpc'
import GuruCoUKFormInputFields from './inputfields/gurucouk'
import PantheonFormInputFields from './inputfields/pantheon'
import DreamHostFormInputFields from './inputfields/dreamhost'
import InMotionHostingFormInputFields from './inputfields/inmotion'
import A2HostingFormInputFields from './inputfields/a2hosting'
import SandboxFormInputFields from './inputfields/sandbox'
import PressableFormInputFields from './inputfields/pressable'
import PagelyFormInputFields from './inputfields/pagely'
import KinstaFormInputFields from './inputfields/kinsta'

class Forms extends Component{
	render(){
		const { formType, failed_fields, fields } = this.props
		switch (formType){
		case HOSTS.WPENGINE: return <WPEngineFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.SAVVII: return <SavviiFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.CLOUDWAYS: return <CloudwaysFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.WEFOSTER: return <WeFosterFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.SITEGROUND: return <SiteGroundFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.HOSTGATOR: return <HostGatorFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.FLYWHEEL: return <FlywheelFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.GODADDY: return <GoDaddyFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.WPSERVEUR: return <WPServeurFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.LIQUIDWEB: return <LiquidWebFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.NEXCESS: return <NexcessFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.BLUEHOST: return <BluehostFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.HOSTINGER: return <HostingerFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.INTERSERVER: return <InterServerFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.JAGUARPC: return <JaguarPCFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.GURUCOUK: return <GuruCoUKFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.GENERIC:	return <GenericFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.CPANEL: return <CPanelFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.PANTHEON: return <PantheonFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.DREAMHOST: return <DreamHostFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.INMOTION: return <InMotionHostingFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.A2HOSTING: return <A2HostingFormInputFields errors={failed_fields} fields={fields} />
		case HOSTS.SANDBOX: return <SandboxFormInputFields errors={failed_fields} fields={fields}/>
		case HOSTS.PRESSABLE: return <PressableFormInputFields errors={failed_fields} fields={fields}/>
		case HOSTS.PAGELY: return <PagelyFormInputFields errors={failed_fields} fields={fields}/>
		case HOSTS.KINSTA: return <KinstaFormInputFields errors={failed_fields} fields={fields}/>
		default: return null
		}
	}
}

export default Forms
